import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import _fill from 'lodash/fill';
import styles from './tableGrid.module.scss';
var rows = _fill(Array(8), 1);
var grid = _fill(Array(8), _toConsumableArray(rows));
var TableGrid = function TableGrid(props) {
  var handleSubmit = props.handleSubmit;
  var _useState = useState({
      cols: 0,
      rows: 0
    }),
    _useState2 = _slicedToArray(_useState, 2),
    size = _useState2[0],
    setSize = _useState2[1];
  var handleHover = function handleHover(rowIndex, columnIndex) {
    setSize({
      cols: columnIndex + 1,
      rows: rowIndex + 1
    });
  };
  var handleSelect = function handleSelect() {
    handleSubmit({
      size: size
    });
  };
  var renderCells = function renderCells(row, rowIndex) {
    return row.map(function (cell, columnIndex) {
      var onMouseEnterHandler = function onMouseEnterHandler() {
        return handleHover(rowIndex, columnIndex);
      };
      var isSelected = rowIndex <= size.rows - 1 && columnIndex <= size.cols - 1;
      var className = isSelected ? cx(styles.cellDefault, styles.cellHighlighted) : cx(styles.cellDefault);
      return (
        /*#__PURE__*/
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
        React.createElement("div", {
          /* eslint-disable-next-line react/no-array-index-key */
          key: "".concat(rowIndex, "-").concat(columnIndex),
          role: "table grid",
          className: className,
          onMouseEnter: onMouseEnterHandler,
          onMouseDown: handleSelect
        })
      );
    });
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles.gridContainer
  }, grid.map(function (row, rowIndex) {
    return /*#__PURE__*/React.createElement("div", {
      /* eslint-disable-next-line react/no-array-index-key */
      key: rowIndex,
      className: styles.gridRow
    }, renderCells(row, rowIndex));
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      margin: 10,
      fontSize: 12
    }
  }, __('Insert table size: {{cols}} x {{rows}}', {
    cols: size.cols,
    rows: size.rows
  })));
};
TableGrid.propTypes = {
  handleSubmit: PropTypes.func.isRequired
};
export default TableGrid;